
const bomData = {
    // 带命名空间的模块
    namespaced: true,
    state: {
      bomTreeData:{},
    },
  
    mutations: {
      SET_DATA: (state, data) => {
        state.bomTreeData[data.key] = data.value
      },
      REMOVE_DATAL:(state)=>{
          state.bomTreeData = {}
      }
    },
    actions: {
    GET_DATA: (state, key) => {
        return state.state.bomTreeData[key]
    },
    }
  }
  
  export default bomData